export default {
  namespaced: true,
  state: {
    // The Institutions currently visible
    active: [],
    // Used to indicate when waiting on the server
    loading: false,
    // The search string being applied
    search: '',
    // What filters are currently applied
    filters: {},
    // The total records matching the filter according to the server (for pagination)
    total: 0,
    // The current page being viewed and its size
    page: 1,
    rowsPerPage: 25,
    // Sorting
    sort: {
      by: 'updatedAt',
      descending: false
    }
  },
  getters: {
    find: state => id => state.active.find(institution => institution.id == id)
  },
  mutations: {
    setActive(
      state,
      {
        items = [],
        page = 1,
        per = 25,
        total = 0,
        search = null,
        sort = { by: 'updatedAt', descending: true },
        filters = {}
      }
    ) {
      state.search = search
      state.active = items
      state.sort = sort
      state.filters = filters
      state.page = page
      state.rowsPerPage = per
      state.total = total
      state.loading = false
    },
    set(state, profile) {
      state.active = state.active.filter(o => o.id != profile.id)
      state.active.push(profile)
    },
    remove(state, id) {
      state.active = state.active.filter(o => o.id != id)
    }
  },
  actions: {
    search(
      { commit, state },
      { search = '', page = 1, rowsPerPage = 25, sortBy = 'profile_qualifications_count', descending = true, filters = {} }
    ) {
      this.$authorize('list', 'Institution')

      const params = {
        search: search,
        page: page,
        per: rowsPerPage,
        sort: `${sortBy} ${descending ? 'DESC' : 'ASC'}`,
        ...filters
      }

      state.loading = true
      return Vue.$http
        .get('admin/institutions', { params })
        .then(response => commit('setActive', response.data), error => (state.loading = false))
    },
    fetch({ commit }, id) {
      this.$authorize('read', 'Institution')

      return Vue.$http.get(`admin/institutions/${id}`).then(response => commit('set', response.data))
    },
    create({ commit }, institution) {
      this.$authorize('create', 'Institution')

      return Vue.$http.post('admin/institutions', { institution }).then(
        response => {
          commit('set', response.data)
          commit('snackbar', { text: 'Institution was created successfully', type: 'success' }, { root: true })
          return response
        },
        error => {
          commit('snackbar', { text: 'Institution could not be created', type: 'error' }, { root: true })
          // console.log('error')
          return Object.assign(profile, error.response.data)
        }
      )
    },
    update({ commit }, institution) {
      this.$authorize('edit', 'Institution')

      return Vue.$http
        .patch(`admin/institutions/${institution.id}`, { institution })
        .then(response => commit('set', response.data))
        .catch(error => commit('set', Object.assign(institution, { errors: error.response.data.errors })))
    },
    destroy({ commit }, id) {
      this.$authorize('delete', 'Institution')

      return Vue.$http.delete(`admin/institutions/${id}`).then(
        (response) => commit('remove', id)
      )
    }
  }
}
